import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useModal, { useSetModal } from "@/shared/atoms/useModal";
import useBranchId from "@/shared/hooks/useBranchId";
import CourierQrLoginModal from "@/Pages/Auth/Deliverer/Map/CourierQrLoginModal";
import MapOrdersSelectModal from "@/Pages/Auth/Deliverer/Map/MapOrdersSelectModal";
import KioskCheckout from "@/Pages/Auth/Maps/KioskCheckout";
import KioskLanguages from "@/Pages/Auth/Maps/KioskLanguages";
import MapSettingsModal from "../Map/MapSettingsModal";
import CustomerOrderHistoryModal from "../Modal/CustomerOrderHistoryModal";
import OnboardingCreateModal from "../Modal/OnboardingCreateModal";
import AboutUsImageModal from "./AboutUsImageModal";
import ActivityModal from "./ActivityModal";
import AddUrlModal from "./AddUrlModal";
import ChangeOfflinePaymentModal from "./ChangeOfflinePaymentModal";
import ColorTemplateModal from "./ColorTemplateModal";
import CopyToppingsModal from "./CopyToppingsModal";
import CourierPrivacyModal from "./CourierPrivacyModal";
import DeliverersMapModal from "./DeliverersMapModal";
import FinancialReportReceiptSettingModal from "./FinancialReportReceiptSettingModal";
import FindMyZipcodes from "./FindMyZipcodes";
import InternalNotificationDeleteModal from "./InternalNotificationDeleteModal";
import InternalNotificationReplyModal from "./InternalNotificationReplyModal";
import LoginAsCustomerModal from "./LoginAsCustomerModal";
import MapOrdersSettingsModal from "./MapOrdersSettingsModal";
import MenuCategoryModal from "./MenuCategoryModal";
import MenuConfirmationModal from "./MenuConfirmationModal";
import MenuFastAllergen from "./MenuFastAllergen";
import MenuFastExtrasModal from "./MenuFastExtrasModal";
import MenuFastGarnishModal from "./MenuFastGarnishModal";
import MenuFastLabel from "./MenuFastLabel";
import MenuFastVats from "./MenuFastVats";
import MenuGarnishModal from "./MenuGarnishModal";
import MenuProductModal from "./MenuProductModal";
import MenuRecommendedProductModal from "./MenuRecommendedProductModal";
import MenuDescriptionsModal from "./MenuDescriptionsModal";
import MenuScanBarcode from "./MenuScanBarcode";
import ProductImageModal from "./ProductImage/ProductImageModal";
import MenuToppingModal from "./MenuToppingModal";
import OrderProductsModal from "./OrderProductsModal";
import PosOrderDiscountCodeModal from "./PosOrderDiscountCodeModal";
import PosOrderRemarkModal from "./PosOrderRemarkModal";
import PosOrderResetCartModal from "./PosOrderResetCartModal";
import PosTableModal from "./PosTableModal";
import ProductReviewsModal from "./ProductReviewsModal";
import QrModal from "./QrModal";
import QrPrintModal from "./QrPrintModal";
import AllergenPosterModal from "./AllergenPosterModal";
import QrSettingsModal from "./QrSettingsModal";
import ReorderFlyerModal from "./ReorderFlyerModal";
import ReplyViaEmailModal from "./ReplyViaEmailModal";
import ReviewGeneratorSelectionModal from "./ReviewGeneratorSelectionModal";
import ScheduleDepositModal from "./ScheduleDepositModal";
import SchedulesPrintModal from "./SchedulesPrintModal";
import ScheduleRosterModal from "./ScheduleRosterModal";
import ScreenModal from "./ScreenModal";
import PickupScreenSettingsModal from "./PickupScreenSettingsModal";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
import ThemeCloneModal from "./ThemeCloneModal";
import ThemeDeleteConfirmationModal from "./ThemeDeleteConfirmationModal";
import PosOrderChangeLabelModal from "./PosOrderChangeLabelModal";
import PersonnelCheckInModal from "./PersonnelCheckInModal";
import AssignCourierModal from "./AssignCourierModal";
import PosOrderPendingPaymentDecisionModal from "./PosOrderPendingPaymentDecisionModal";
import OrderModal from "./OrderModal";
import PosOrderSelectToppingsModal from "./PosOrderSelectToppingsModal";
import PosOrderProductModal from "./PosOrderProductModal";
import PosOrderCustomDiscountModal from "./PosOrderCustomDiscountModal";
import PrintReceiptModal from "./PrintReceiptModal";
import SystemTrackerModal from "../Modal/SystemTrackerModal";
import MapModal from "@/Pages/Auth/Maps/MapModal";
import TableModal from "@/Pages/Auth/Maps/TableModal";
import DepositModal from "./DepositModal";
import PrintSessionReceipt from "./PrintSessionReceipt";
import RefundModal from "./RefundModal";
import OrderUserModal from "./OrderUserModal";
import SplitPaymentV2Modal from "./SplitPaymentV2Modal";
import CartItemNoteModal from "./CartItemNoteModal";
import KioskCartItemNoteModal from "./KioskCartItemNoteModal";
import DelivererOverviewModal from "@/Pages/Auth/Deliverer/Deliverers/DelivererOverviewModal";
import PosChangeTablesModal from "@/Pages/Auth/Bestellingen/PosOrder/PosChangeTablesModal";
import PosMergeSessions from "@/Pages/Auth/Bestellingen/PosOrder/PosMergeSessionsModal";
import OrdersMapModal from "./OrdersMapModal";
import ZipcodeMapModal from "./ZipcodeMapModal";
import TableOrdersModal from "@/Pages/Auth/Maps/TableOrdersModal";
import BranchSelectModal from "./BranchSelectModal";
import PosCartPaymentModal from "./PosCartPaymentModal";
import PosDeliveryMethodModal from "./PosDeliveryMethodModal";

const Modals = () => {
  const location = useLocation();
  const [{ type }] = useModal();
  const branch = useBranchId();

  const setModal = useSetModal();
  const onExit = useCallback(() => {
    return setModal("", {});
  }, []);

  useEffect(() => {
    onExit();
  }, [branch]);

  useEffect(() => {
    setModal("");
  }, [location.pathname]);

  return (
    <>
      {type === "posOrderSelectToppings" && (
        <PosOrderSelectToppingsModal onExit={onExit} />
      )}
      {type === "order" && <OrderModal onExit={onExit} />}
      {type === "orderUser" && <OrderUserModal onExit={onExit} />}
      {type === "refund" && <RefundModal onExit={onExit} />}
      {type === "deposit" && <DepositModal onExit={onExit} />}
      {type === "map" && <MapModal onExit={onExit} />}
      {type === "table" && <TableModal onExit={onExit} />}
      {type === "systemTracker" && <SystemTrackerModal onExit={onExit} />}
      {type === "printSessionReceipt" && (
        <PrintSessionReceipt onExit={onExit} />
      )}
      {type === "printReceipt" && <PrintReceiptModal onExit={onExit} />}
      {type === "posOrderDiscount" && (
        <PosOrderCustomDiscountModal onExit={onExit} />
      )}
      {type === "cartItemNote" && <CartItemNoteModal onExit={onExit} />}
      {type === "splitPayment" && <SplitPaymentV2Modal onExit={onExit} />}
      {type === "posCartPayment" && <PosCartPaymentModal onExit={onExit} />}
      {type === "deliverOverview" && <DelivererOverviewModal onExit={onExit} />}
      {type === "posOrderProduct" && <PosOrderProductModal onExit={onExit} />}
      {type === "changeTables" && <PosChangeTablesModal onExit={onExit} />}
      {type === "mergeSessions" && <PosMergeSessions onExit={onExit} />}
      {type === "ordersMapModal" && <OrdersMapModal onExit={onExit} />}
      {type === "zipcodeMapModal" && <ZipcodeMapModal onExit={onExit} />}
      {type === "tableOrders" && <TableOrdersModal />}

      {type === "kioskCheckout" && <KioskCheckout onExit={onExit} />}
      {type === "kioskCartItemNote" && (
        <KioskCartItemNoteModal onExit={onExit} />
      )}
      {type === "kioskLanguages" && <KioskLanguages onExit={onExit} />}
      {type === "activity" && <ActivityModal onExit={onExit} />}
      {type === "mapOrdersMap" && <DeliverersMapModal onExit={onExit} />}
      {type === "screen" && <ScreenModal onExit={onExit} />}
      {type === "pickupScreenSettings" && (
        <PickupScreenSettingsModal onExit={onExit} />
      )}
      {type === "scheduleDeposit" && <ScheduleDepositModal onExit={onExit} />}
      {type === "mapOrdersSelect" && <MapOrdersSelectModal onExit={onExit} />}
      {type === "courierQrLogin" && <CourierQrLoginModal onExit={onExit} />}
      {type === "mapOrdersSettings" && (
        <MapOrdersSettingsModal onExit={onExit} />
      )}
      {type === "mapSettings" && <MapSettingsModal onExit={onExit} />}
      {type === "copyToppings" && <CopyToppingsModal onExit={onExit} />}
      {type === "orderProducts" && <OrderProductsModal onExit={onExit} />}
      {type === "qr" && <QrModal onExit={onExit} />}
      {type === "qrSettings" && <QrSettingsModal onExit={onExit} />}
      {type === "posTable" && <PosTableModal onExit={onExit} />}
      {type === "qrPrint" && <QrPrintModal onExit={onExit} />}
      {type === "allergenPoster" && <AllergenPosterModal onExit={onExit} />}
      {type === "loginAsCustomer" && <LoginAsCustomerModal onExit={onExit} />}
      {type === "schedulesPrint" && <SchedulesPrintModal onExit={onExit} />}
      {type === "scheduleRoster" && <ScheduleRosterModal onExit={onExit} />}
      {type === "productReviews" && <ProductReviewsModal onExit={onExit} />}
      {type === "findMyZipcodes" && <FindMyZipcodes onExit={onExit} />}
      {type === "reviewGeneratorSelection" && (
        <ReviewGeneratorSelectionModal onExit={onExit} />
      )}
      {type === "menuFastExtras" && <MenuFastExtrasModal onExit={onExit} />}
      {type === "menuProduct" && <MenuProductModal onExit={onExit} />}
      {type === "menuCategory" && <MenuCategoryModal onExit={onExit} />}
      {type === "menuConfirmation" && <MenuConfirmationModal onExit={onExit} />}
      {type === "menuGarnish" && <MenuGarnishModal onExit={onExit} />}
      {type === "menuTopping" && <MenuToppingModal onExit={onExit} />}
      {type === "menuFastGarnish" && <MenuFastGarnishModal onExit={onExit} />}
      {type === "menuFastLabel" && <MenuFastLabel onExit={onExit} />}
      {type === "menuFastAllergen" && <MenuFastAllergen onExit={onExit} />}
      {type === "menuFastVats" && (
        <MenuFastVats onExit={onExit} width="120rem" />
      )}
      {type === "menuDescriptions" && <MenuDescriptionsModal onExit={onExit} />}
      {type === "menuRecommendedProduct" && (
        <MenuRecommendedProductModal onExit={onExit} />
      )}
      {type === "courierPrivacy" && <CourierPrivacyModal />}
      {type === "colorTemplate" && <ColorTemplateModal onExit={onExit} />}
      {type === "changeOfflinePayment" && (
        <ChangeOfflinePaymentModal onExit={onExit} />
      )}
      {type === "replyViaEmail" && <ReplyViaEmailModal onExit={onExit} />}
      {type === "internalNotificationDelete" && (
        <InternalNotificationDeleteModal />
      )}
      {type === "internalNotificationReply" && (
        <InternalNotificationReplyModal onExit={onExit} />
      )}
      {type === "posOrderRemark" && <PosOrderRemarkModal onExit={onExit} />}
      {type === "posOrderDiscountCode" && (
        <PosOrderDiscountCodeModal onExit={onExit} />
      )}
      {type === "posOrderResetCart" && <PosOrderResetCartModal />}
      {type === "termsAndConditions" && <TermsAndConditionsModal />}
      {type === "menuScanBarcode" && <MenuScanBarcode onExit={onExit} />}
      {type === "menuProductImage" && <ProductImageModal onExit={onExit} />}
      {type === "aboutUsImage" && <AboutUsImageModal onExit={onExit} />}
      {type === "themeDeleteConfirmation" && (
        <ThemeDeleteConfirmationModal onExit={onExit} />
      )}
      {type === "themeClone" && <ThemeCloneModal onExit={onExit} />}
      {type === "reorderFlyer" && <ReorderFlyerModal onExit={onExit} />}
      {type === "onboardingCreate" && <OnboardingCreateModal onExit={onExit} />}
      {type === "addUrl" && <AddUrlModal onExit={onExit} />}
      {type === "customerOrderHistory" && (
        <CustomerOrderHistoryModal onExit={onExit} />
      )}
      {type === "financialReportReceiptSettings" && (
        <FinancialReportReceiptSettingModal onExit={onExit} />
      )}
      {type === "posOrderChangeLabel" && (
        <PosOrderChangeLabelModal onExit={onExit} />
      )}
      {type === "personnelCheckIn" && <PersonnelCheckInModal onExit={onExit} />}
      {type === "assignCourier" && <AssignCourierModal onExit={onExit} />}
      {type === "posOrderPendingPaymentDecision" && (
        <PosOrderPendingPaymentDecisionModal onExit={onExit} />
      )}
      {type === "branchSelect" && <BranchSelectModal />}
      {type === "posDeliveryMethod" && (
        <PosDeliveryMethodModal onExit={onExit} />
      )}
    </>
  );
};

export default Modals;
